<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-data-table
                                    :headers="objectHeaders"
                                    :items="objectList"
                                    fixed-header
                                    dense
                                    class="row-item"
                                    :items-per-page="-1"
                                    :hide-default-footer="true"
                                    :height="200"
                                    :no-data-text="$t('labels.noData')"
                                >
                                    <template v-slot:item="row">
                                        <tr>
                                            <td>
                                                {{ row.item.entity_name }}
                                            </td>
                                            <td>
                                                {{ row.item.rank_display }}
                                            </td>
                                            <td>
                                                {{ row.item.maritime_object_name }}
                                            </td>
                                            <td>
                                                {{ row.item.signed_on_display }}
                                            </td>
                                            <td>
                                                {{ row.item.signed_off_display }}
                                            </td>
                                            <td>
                                                {{ row.item.duration }}
                                            </td>
                                            <td>
                                                {{ row.item.vessel_type_display }}
                                            </td>
                                            <td>
                                                {{ row.item.dwt }}
                                            </td>
                                            <td>
                                                {{ row.item.gt }}
                                            </td>
                                            <td>
                                                {{ row.item.engine_type_name }}
                                            </td>
                                            <td>
                                                {{ row.item.kw }}
                                            </td>
                                            <td>
                                                {{ row.item.dp_manufacturer_name }}
                                            </td>
                                            <td>
                                                {{ row.item.dp_type_name }}
                                            </td>
                                            <td v-if="inEditMode">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{on, attrs}">
                                                        <v-btn icon v-bind="attrs" @click="remove(row.item)" v-on="on">
                                                            <v-icon small>fas fa-trash</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{ $t('tooltips.delete') }}</span>
                                                </v-tooltip>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-slot:footer>
                                        <td style="width: 100%" v-if="inEditMode" class="text-left">
                                            <v-row dense>
                                                <v-col>
                                                    <v-btn
                                                        class="ml-2 mr-2"
                                                        color="primary"
                                                        @click="newObjectDialog = true"
                                                    >
                                                        <v-icon small>fas fa-plus</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td v-else style="width: 5%"></td>
                                    </template>
                                    <!-- <template v-slot:footer>
                                        <td style="width: 10%">
                                            <v-row dense>
                                                <v-col v-if="type == 1">
                                                    <Dropdown
                                                        :readonly="!inEditMode"
                                                        v-model="object.entity_id"
                                                        :errorBorder="!objectValidation.entity_id"
                                                        :ajax="true"
                                                        :data="'entities'"
                                                        :label="$t('fields.companyName')"
                                                    ></Dropdown>
                                                </v-col>
                                                <v-col v-else>
                                                    <InputField
                                                        :readonly="!inEditMode"
                                                        :maxlength="50"
                                                        v-model="object.entity_name"
                                                        :errorBorder="!objectValidation.entity_name"
                                                        :label="'* ' + $t('fields.companyName')"
                                                    ></InputField>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td style="width: 5%">
                                            <v-row dense>
                                                <v-col>
                                                    <Dropdown
                                                        :readonly="!inEditMode"
                                                        v-model="object.rank_id"
                                                        :errorBorder="!objectValidation.rank_id"
                                                        :ajax="true"
                                                        :data="'ranks-abbreviation'"
                                                        :label="$t('fields.rank')"
                                                    ></Dropdown>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td style="width: 10%">
                                            <v-row dense>
                                                <v-col v-if="type == 1">
                                                    <Dropdown
                                                        :readonly="!inEditMode"
                                                        v-model="object.maritime_object_id"
                                                        :errorBorder="!objectValidation.maritime_object_id"
                                                        :ajax="true"
                                                        :data="'maritime-objects'"
                                                        :label="$t('fields.vessel')"
                                                    ></Dropdown>
                                                </v-col>
                                                <v-col v-else>
                                                    <InputField
                                                        :readonly="!inEditMode"
                                                        :maxlength="50"
                                                        v-model="object.maritime_object_name"
                                                        :errorBorder="!objectValidation.maritime_object_name"
                                                        :label="'* ' + $t('fields.vessel')"
                                                    ></InputField>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td style="width: 5%">
                                            <v-row dense>
                                                <v-col>
                                                    <DatePicker
                                                        :readonly="!inEditMode"
                                                        v-model="object.signed_on"
                                                        :errorBorder="!objectValidation.signed_on"
                                                        :date-label="$t('fields.signedOn')"
                                                    ></DatePicker>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td style="width: 5%">
                                            <v-row dense>
                                                <v-col>
                                                    <DatePicker
                                                        :readonly="!inEditMode"
                                                        v-model="object.signed_off"
                                                        :errorBorder="!objectValidation.signed_off"
                                                        :date-label="$t('fields.signedOff')"
                                                    ></DatePicker>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td style="width: 3%">
                                            <v-row dense>
                                                <v-col>
                                                    <InputField
                                                        :readonly="true"
                                                        :maxlength="50"
                                                        v-model="object.duration"
                                                        :errorBorder="!objectValidation.duration"
                                                        :label="'* ' + $t('fields.duration')"
                                                    ></InputField>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td style="width: 10%">
                                            <v-row dense>
                                                <v-col>
                                                    <Dropdown
                                                        :readonly="!inEditMode"
                                                        v-model="object.vessel_type_id"
                                                        :errorBorder="!objectValidation.vessel_type_id"
                                                        :ajax="true"
                                                        :data="'vessel-types'"
                                                        :label="$t('fields.typeOfvessel')"
                                                    ></Dropdown>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td style="width: 5%">
                                            <v-row dense>
                                                <v-col>
                                                    <InputField
                                                        :readonly="!inEditMode"
                                                        :maxlength="50"
                                                        v-model="object.dwt"
                                                        :errorBorder="!objectValidation.dwt"
                                                        :label="'* ' + $t('fields.dwt')"
                                                    ></InputField>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td style="width: 5%">
                                            <v-row dense>
                                                <v-col>
                                                    <InputField
                                                        v-if="type == 2"
                                                        :readonly="!inEditMode"
                                                        :maxlength="50"
                                                        v-model="object.gt"
                                                        :errorBorder="!objectValidation.gt"
                                                        :label="$t('fields.gt')"
                                                    ></InputField>
                                                    <InputField
                                                        v-else
                                                        :readonly="!inEditMode"
                                                        :maxlength="50"
                                                        v-model="object.gt"
                                                        :errorBorder="!objectValidation.gt"
                                                        :label="'* ' + $t('fields.gt')"
                                                    ></InputField>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td style="width: 10%">
                                            <v-row dense>
                                                <v-col v-if="type == 1 || type == 2">
                                                    <Dropdown
                                                        :readonly="!inEditMode"
                                                        v-model="object.engine_type_id"
                                                        :errorBorder="!objectValidation.engine_type_id"
                                                        :ajax="true"
                                                        :data="'engine-types'"
                                                        :label="$t('fields.engineType')"
                                                    ></Dropdown>
                                                </v-col>
                                                <v-col v-else>
                                                    <InputField
                                                        :readonly="!inEditMode"
                                                        :maxlength="50"
                                                        v-model="object.engine_type_name"
                                                        :errorBorder="!objectValidation.engine_type_name"
                                                        :label="'* ' + $t('fields.engineType')"
                                                    ></InputField>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td style="width: 5%">
                                            <v-row dense>
                                                <v-col>
                                                    <InputField
                                                        :readonly="!inEditMode"
                                                        :maxlength="50"
                                                        v-model="object.kw"
                                                        :errorBorder="!objectValidation.kw"
                                                        :label="'* ' + $t('fields.kW')"
                                                    ></InputField>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td style="width: 10%">
                                            <v-row dense>
                                                <v-col v-if="type == 1 || type == 2">
                                                    <Dropdown
                                                        :readonly="!inEditMode"
                                                        v-model="object.dp_manufacturer_id"
                                                        :errorBorder="!objectValidation.dp_manufacturer_id"
                                                        :ajax="true"
                                                        :data="'dp-manufacturers'"
                                                        :label="$t('fields.dpManufacturer')"
                                                    ></Dropdown>
                                                </v-col>
                                                <v-col v-else>
                                                    <InputField
                                                        :readonly="!inEditMode"
                                                        :maxlength="50"
                                                        v-model="object.dp_manufacturer_name"
                                                        :errorBorder="!objectValidation.dp_manufacturer_name"
                                                        :label="'* ' + $t('fields.dpManufacturer')"
                                                    ></InputField>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td style="width: 10%">
                                            <v-row dense>
                                                <v-col v-if="type == 1 || type == 2">
                                                    <Dropdown
                                                        :readonly="!inEditMode"
                                                        v-model="object.dp_type_id"
                                                        :errorBorder="!objectValidation.dp_type_id"
                                                        :ajax="true"
                                                        :data="'dp-types'"
                                                        :label="$t('fields.dpType')"
                                                    ></Dropdown>
                                                </v-col>
                                                <v-col v-else>
                                                    <InputField
                                                        :readonly="!inEditMode"
                                                        :maxlength="50"
                                                        v-model="object.dp_type_name"
                                                        :errorBorder="!objectValidation.dp_type_name"
                                                        :label="'* ' + $t('fields.dpType')"
                                                    ></InputField>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td style="width: 5%" v-if="inEditMode">
                                            <v-row dense>
                                                <v-col>
                                                    <v-btn
                                                        class="ml-2 mr-2"
                                                        color="primary"
                                                        @click="newObjectDialog = true"
                                                    >
                                                        <v-icon small>fa-save</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td v-else style="width: 5%"></td>
                                    </template> -->
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-dialog v-model="newObjectDialog" persistent width="700">
                <v-card>
                    <v-card-title v-if="type == 1">
                        {{ $t('labels.newExperienceWithAzara') }}
                    </v-card-title>
                    <v-card-title v-else-if="type == 2">
                        {{ $t('labels.newExperienceWithOtherCompanies') }}
                    </v-card-title>
                    <v-card-title v-else>
                        {{ $t('labels.newOnShoreExperience') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row dense wrap>
                            <v-col cols="6">
                                <v-row dense wrap>
                                    <v-col cols="12" v-if="type == 1">
                                        <Dropdown
                                            :readonly="!inEditMode"
                                            v-model="object.entity_id"
                                            :errorBorder="!objectValidation.entity_id"
                                            :ajax="true"
                                            :data="'entities'"
                                            :label="'* ' + $t('fields.companyName')"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12" v-else>
                                        <InputField
                                            :readonly="!inEditMode"
                                            :maxlength="50"
                                            v-model="object.entity_name"
                                            :errorBorder="!objectValidation.entity_name"
                                            :label="'* ' + $t('fields.companyName')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <Dropdown
                                            :readonly="!inEditMode"
                                            v-model="object.rank_id"
                                            :errorBorder="!objectValidation.rank_id"
                                            :ajax="true"
                                            :data="'ranks-abbreviation'"
                                            :label="'* ' + $t('fields.rank')"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12" v-if="type == 1">
                                        <Dropdown
                                            :readonly="!inEditMode"
                                            v-model="object.maritime_object_id"
                                            :errorBorder="!objectValidation.maritime_object_id"
                                            :ajax="true"
                                            :data="'maritime-objects'"
                                            :label="'* ' + $t('fields.vesselName')"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12" v-else>
                                        <InputField
                                            :readonly="!inEditMode"
                                            :maxlength="50"
                                            v-model="object.maritime_object_name"
                                            :errorBorder="!objectValidation.maritime_object_name"
                                            :label="'* ' + $t('fields.vesselName')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <DatePicker
                                            :readonly="!inEditMode"
                                            v-model="object.signed_on"
                                            :errorBorder="!objectValidation.signed_on"
                                            :date-label="'* ' + $t('fields.signedOn')"
                                        ></DatePicker>
                                    </v-col>
                                    <v-col cols="12">
                                        <DatePicker
                                            :readonly="!inEditMode"
                                            v-model="object.signed_off"
                                            :errorBorder="!objectValidation.signed_off"
                                            :date-label="'* ' + $t('fields.signedOff')"
                                        ></DatePicker>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :readonly="true"
                                            :maxlength="50"
                                            v-model="object.duration"
                                            :errorBorder="!objectValidation.duration"
                                            :label="'* ' + $t('fields.duration')"
                                        ></InputField>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="6">
                                <v-row dense wrap>
                                    <v-col cols="12">
                                        <Dropdown
                                            :readonly="!inEditMode"
                                            v-model="object.vessel_type_id"
                                            :errorBorder="!objectValidation.vessel_type_id"
                                            :ajax="true"
                                            :data="'vessel-types'"
                                            :label="$t('fields.typeOfvessel')"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :readonly="!inEditMode"
                                            :maxlength="50"
                                            v-model="object.dwt"
                                            :errorBorder="!objectValidation.dwt"
                                            :label="$t('fields.dwt')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            v-if="type == 2"
                                            :readonly="!inEditMode"
                                            :maxlength="50"
                                            v-model="object.gt"
                                            :errorBorder="!objectValidation.gt"
                                            :label="$t('fields.gt')"
                                        ></InputField>
                                        <InputField
                                            v-else
                                            :readonly="!inEditMode"
                                            :maxlength="50"
                                            v-model="object.gt"
                                            :errorBorder="!objectValidation.gt"
                                            :label="'* ' + $t('fields.gt')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12" v-if="type == 1 || type == 2">
                                        <Dropdown
                                            :readonly="!inEditMode"
                                            v-model="object.engine_type_id"
                                            :errorBorder="!objectValidation.engine_type_id"
                                            :ajax="true"
                                            :data="'engine-types'"
                                            :label="$t('fields.engineType')"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12" v-else>
                                        <InputField
                                            :readonly="!inEditMode"
                                            :maxlength="50"
                                            v-model="object.engine_type_name"
                                            :errorBorder="!objectValidation.engine_type_name"
                                            :label="'* ' + $t('fields.engineType')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12">
                                        <InputField
                                            :readonly="!inEditMode"
                                            :maxlength="50"
                                            v-model="object.kw"
                                            :errorBorder="!objectValidation.kw"
                                            :label="$t('fields.kW')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12" v-if="type == 1 || type == 2">
                                        <Dropdown
                                            :readonly="!inEditMode"
                                            v-model="object.dp_manufacturer_id"
                                            :errorBorder="!objectValidation.dp_manufacturer_id"
                                            :ajax="true"
                                            :data="'dp-manufacturers'"
                                            :label="$t('fields.dpManufacturer')"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12" v-else>
                                        <InputField
                                            :readonly="!inEditMode"
                                            :maxlength="50"
                                            v-model="object.dp_manufacturer_name"
                                            :errorBorder="!objectValidation.dp_manufacturer_name"
                                            :label="'* ' + $t('fields.dpManufacturer')"
                                        ></InputField>
                                    </v-col>
                                    <v-col cols="12" v-if="type == 1 || type == 2">
                                        <Dropdown
                                            :readonly="!inEditMode"
                                            v-model="object.dp_type_id"
                                            :errorBorder="!objectValidation.dp_type_id"
                                            :ajax="true"
                                            :data="'dp-types'"
                                            :label="$t('fields.dpType')"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12" v-else>
                                        <InputField
                                            :readonly="!inEditMode"
                                            :maxlength="50"
                                            v-model="object.dp_type_name"
                                            :errorBorder="!objectValidation.dp_type_name"
                                            :label="'* ' + $t('fields.dpType')"
                                        ></InputField>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-col
                            cols="12"
                            md="6"
                            class="text-right"
                            :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                        >
                            <v-btn color="primary" class="white--text" @click.stop="saveClick()"
                                >{{ $t('buttons.save') }}
                            </v-btn>
                        </v-col>
                        <v-col
                            cols="12"
                            md="6"
                            class="text-left"
                            :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                        >
                            <v-btn color="secondary" class="white--text" @click.stop="closeDialog()"
                                >{{ $t('buttons.cancel') }}
                            </v-btn>
                        </v-col>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import SeafarerNavigation from '../models/SeafarerNavigation';
import DatePicker from '@/components/trinkets/DatePicker';
import Dropdown from './trinkets/Dropdown';
import InputField from './trinkets/InputField';
export default {
    name: 'BasicObject',
    components: {
        InputField,
        DatePicker,
        Dropdown,
    },
    props: ['seafarer', 'inEditMode', 'type', 'reload'],
    data: function () {
        return {
            newObjectDialog: false,
            object: new SeafarerNavigation({}),
            objectValidation: new SeafarerNavigation({}, true),
            objectList: [],
            objectHeaders: [
                {text: this.$t('fields.companyName'), width: '10%', sortable: false},
                {text: this.$t('fields.rank'), width: '5%', sortable: false},
                {text: this.$t('fields.vesselName'), width: '10%', sortable: false},
                {text: this.$t('fields.signedOn'), width: '5%', sortable: false},
                {text: this.$t('fields.signedOff'), width: '5%', sortable: false},
                {text: this.$t('fields.durationDays'), width: '3%', sortable: false},
                {text: this.$t('fields.typeOfvessel'), width: '10%', sortable: false},
                {text: this.$t('fields.dwt'), width: '5%', sortable: false},
                {text: this.$t('fields.gt'), width: '5%', sortable: false},
                {text: this.$t('fields.engineType'), width: '10%', sortable: false},
                {text: this.$t('fields.kW'), width: '5%', sortable: false},
                {text: this.$t('fields.dpManufacturer'), width: '10%', sortable: false},
                {text: this.$t('fields.dpType'), width: '10%', sortable: false},
                {text: '', value: 'actions', type: '', sortable: false, width: '5%', allowFilter: false},
            ],
        };
    },

    watch: {
        'object.maritime_object_id': {
            handler: function () {
                let vm = this;
                this.$APICall('get', 'maritime-objects/' + this.object.maritime_object_id, {}, (data, success) => {
                    if (success) {
                        let usableData = JSON.parse(JSON.stringify(data));
                        vm.object.vessel_name = usableData.name;
                        vm.object.entity_id = usableData.maritime_object_owner_id;
                        if (usableData.maritime_object_type_id == 1) {
                            vm.$APICall('get', 'vessels/' + usableData.vessel_id, {}, (data, succes) => {
                                if (succes) {
                                    let vesseldata = JSON.parse(JSON.stringify(data));
                                    vm.object.vessel_type_id = vesseldata.vessel_type.id;
                                    vm.object.dwt = vesseldata.dwt;
                                    vm.object.gt = vesseldata.gt;
                                    vm.object.engine_type_id = vesseldata.engine_type_id;
                                    vm.object.kw = vesseldata.propulsion_power;
                                    vm.object.dp_manufacturer_id = vesseldata.dp_manufacturer_id;
                                    vm.object.dp_type_id = vesseldata.dp_type_id;
                                } else {
                                    vm.$alert(vm.$t('alerts.basicError'));
                                }
                            });
                        }
                    }
                });
            },
            deep: true,
        },
        'reload': {
            handler: function () {
                let vm = this;
                if (this.reload != 0) {
                    this.$APICall(
                        'get',
                        'seafarer-navigations/' + this.seafarer.id,
                        {},
                        (data, success) => {
                            if (success) {
                                vm.objectList = data.items;
                                vm.$emit('change', data.total);
                            } else {
                                vm.$alert(vm.$t('alerts.basicError'));
                            }
                        },
                        false,
                    );
                }
            },
            deep: true,
        },

        'object.signed_on': {
            handler: function () {
                this.calculateDuration();
            },
            deep: true,
        },
        'object.signed_off': {
            handler: function () {
                this.calculateDuration();
            },
            deep: true,
        },
    },

    methods: {
        closeDialog() {
            this.newObjectDialog = false;
            this.object = new SeafarerNavigation({});
            this.objectValidation = new SeafarerNavigation({}, true);
        },
        saveClick() {
            let success = true;

            if (this.object.rank_id == null || this.object.rank_id == '') {
                success = false;
                this.objectValidation.rank_id = false;
            } else {
                this.objectValidation.rank_id = true;
            }
            if (this.object.signed_on == null || this.object.signed_on == '') {
                success = false;
                this.objectValidation.signed_on = false;
            } else {
                this.objectValidation.signed_on = true;
            }
            if (this.object.signed_off == null || this.object.signed_off == '') {
                success = false;
                this.objectValidation.signed_off = false;
            } else {
                this.objectValidation.signed_off = true;
            }

            if (this.objectValidation.signed_on == false || this.objectValidation.signed_off == false) {
                success = false;
            }
            if (this.type != 2) {
                if (this.object.gt == null || this.object.gt == '') {
                    success = false;
                    this.objectValidation.gt = false;
                } else {
                    this.objectValidation.gt = true;
                }
            }

            if (this.type == 1) {
                if (this.object.entity_id == null || this.object.entity_id == '') {
                    success = false;
                    this.objectValidation.entity_id = false;
                } else {
                    this.objectValidation.entity_id = true;
                }
                if (this.object.maritime_object_id == null || this.object.maritime_object_id == '') {
                    success = false;
                    this.objectValidation.maritime_object_id = false;
                } else {
                    this.objectValidation.maritime_object_id = true;
                }
            } else {
                if (this.object.entity_name == null || this.object.entity_name == '') {
                    success = false;
                    this.objectValidation.entity_name = false;
                } else {
                    this.objectValidation.entity_name = true;
                }
                if (this.object.maritime_object_name == null || this.object.maritime_object_name == '') {
                    success = false;
                    this.objectValidation.maritime_object_name = false;
                } else {
                    this.objectValidation.maritime_object_name = true;
                }
                if (this.type != 2) {
                    if (this.object.engine_type_name == null || this.object.engine_type_name == '') {
                        success = false;
                        this.objectValidation.engine_type_name = false;
                    } else {
                        this.objectValidation.engine_type_name = true;
                    }
                }

                if (this.type != 2) {
                    if (this.object.dp_manufacturer_name == null || this.object.dp_manufacturer_name == '') {
                        success = false;
                        this.objectValidation.dp_manufacturer_name = false;
                    } else {
                        this.objectValidation.dp_manufacturer_name = true;
                    }
                    if (this.object.dp_type_name == null || this.object.dp_type_name == '') {
                        success = false;
                        this.objectValidation.dp_type_name = false;
                    } else {
                        this.objectValidation.dp_type_name = true;
                    }
                }
            }

            if (success) {
                this.object.seafarer_navigation_type_id = this.type;
                this.object.seafarer_id = this.seafarer.id;
                let vm = this;
                let action = 'post';
                let addition = this.seafarer.id;
                this.$APICall(action, 'seafarer-navigations/' + addition, this.object, (data, succes) => {
                    if (succes) {
                        this.newObjectDialog = false;
                        vm.reloadData();
                        vm.object = new SeafarerNavigation({});
                        vm.objectValidation = new SeafarerNavigation({}, true);
                    }
                });
            }
        },

        calculateDuration() {
            if (this.object.signed_on != null && this.object.signed_off != null) {
                const signedOn = new Date(this.object.signed_on);
                const signedOff = new Date(this.object.signed_off);
                if (signedOn <= signedOff) {
                    var time_difference = signedOff.getTime() - signedOn.getTime();
                    var days_difference = time_difference / (1000 * 60 * 60 * 24);
                    this.object.duration = days_difference;
                    this.objectValidation.signed_on = true;
                    this.objectValidation.signed_off = true;
                } else {
                    this.objectValidation.signed_on = false;
                    this.objectValidation.signed_off = false;
                }
            }
        },

        remove(item) {
            let vm = this;
            let objectId = item.id;
            this.$verify(this.$t('alerts.deletionQuestion'), (result) => {
                if (result) {
                    vm.$APICall('put', 'seafarer-navigations/' + objectId, {}, (data, succes) => {
                        if (succes) {
                            vm.reloadData();
                        } else {
                            vm.$alert(vm.$t('alerts.basicError'));
                        }
                    });
                }
            });
        },

        reloadData() {
            let vm = this;
            let type = this.type;
            this.$APICall(
                'get',
                'seafarer-navigations/' + this.seafarer.id,
                {type},
                (data, success) => {
                    if (success) {
                        vm.objectList = data.items;
                        var totals = [];
                        totals[0] = data.totalMonths;
                        totals[1] = data.totalDays;
                        vm.$emit('change', totals);
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
    },
    mounted() {
        this.reloadData();
    },
};
</script>
